var heightMainMenu = 0;
let namRow = 2;
if ($(window).width() > 1200) {
    namRow = 3;
}

$(document).ready(function () {
    const dimmingMainContent = '<div class="bg_modal"></div>';



    $(document).on('click', '.js_open_menu', function () {
        const button = $(this);
        const heightMenu = $('header').outerHeight();
        const scrollBody = $(window).scrollTop();
        const typeMenu = button.attr('data-menu');
        const blockUse = $(`.menu_block[data-menuBlock=${typeMenu}]`);

        if (button.hasClass('hover')) {
            button.removeClass('hover');

            $('.bg_modal').remove();
            $('body').removeClass('overflow_hidden');
            $('header').removeClass('menu_open');
            blockUse.removeClass('js_open_block');
        } else {
            $('.js_open_menu').removeClass('hover');
            $(`.menu_block`).removeClass('js_open_block');
            $('.bg_modal').remove();
            button.addClass('hover');

            $('footer').after(dimmingMainContent);
            $('body').addClass('overflow_hidden');
            if ($(window).width() > 992) {
                $('header').addClass('menu_open');
            }
            if (typeMenu == 'cats' && $('header').hasClass('js__menu_fix')) {
                // if (scrollBody > 0) {
                blockUse.css('top', `${heightMenu}px`);
                // }
            } else {
                blockUse.css('top', `${heightMenu}px`);
            }
            blockUse.addClass('js_open_block');
            heightMainMenu = $('.first_level_block').outerHeight(true);
            $('.menu_children_menu').css('height', `${heightMainMenu}px`);
        }

        if (typeMenu == 'cart') {
            $(document).on('click', '.bg_modal, .js_close_cart', function () {
                $('.bg_modal').remove();
                $('body').removeClass('overflow_hidden');
                $('header').removeClass('menu_open');
                blockUse.removeClass('js_open_block');
                button.removeClass('hover');
            });
        } else {
            if ($(window).width() < 992) {
                $(document).on('click', '.bg_modal, .js_close_menu', function () {
                    $('.bg_modal').remove();
                    $('body').removeClass('overflow_hidden');
                    $('header').removeClass('menu_open');
                    blockUse.removeClass('js_open_block');
                    button.removeClass('hover');
                    $('.burder_menu').removeClass('js_open');
                });
            } else {
                $(document).on('click', '.bg_modal, .js_open_block', function () {
                    $('.bg_modal').remove();
                    $('body').removeClass('overflow_hidden');
                    $('header').removeClass('menu_open');
                    blockUse.removeClass('js_open_block');
                    button.removeClass('hover');
                    $('.burder_menu').removeClass('js_open');
                });
            }
        }
    });

    $('.js_hover_menu:not(.hover_item_menu)').hover(function () {
        $('.js_hover_menu').removeClass('hover_item_menu');
        $('.second_level').removeClass('js_open_block');
        const catId = $(this).attr('data-catsName');
        $(this).addClass('hover_item_menu');
        $('.menu_children_menu').addClass('js_open_block');
        $('.menu_cats_block').addClass('js_hover_block');
        if (catId) {
            $(`.menu_children_menu .second_level[data-catsChildren=${catId}]`).addClass('js_open_block');
            menuRebuild(namRow);
        }
    });

    let burgerMenu = '';

    $(document).on('click', '.js_open_burger', function () {
        const menuMob = {
            'menu_top_info_list': `<ul class='menu_top_info_list row flex_center'>${$('.menu_top_info_list').html()}</ul>`,
            'menu_top_info_block': `<div class='header_mob_top'>${$('.menu_top_info_block').html()}</div>`,
            'main_menu': $('.main_menu').html(),
        }

        if (burgerMenu == '') {
            burgerMenu = `<div class='mob_body'>
                <button type='button' class='close_button js_close_menu'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'>
                        <path data-name='cross' d='M.227 1.335a.8.8 0 0 1 0-1.11.8.8 0 0 1 1.11 0L8 6.9 14.67.225a.781.781 0 0 1 1.1 1.11L9.108 8l6.661 6.67a.781.781 0 0 1-1.1 1.11L8 9.1l-6.661 6.67a.8.8 0 0 1-1.11 0 .8.8 0 0 1 0-1.11L6.888 8z' transform='translate(-.002)' style='fill:#494b55'/>
                    </svg>
                </button>
                ${menuMob.menu_top_info_block}
                ${menuMob.main_menu}
                ${menuMob.menu_top_info_list}
            </div>`
            $('.burder_menu').append(burgerMenu);
        }

        $('footer').after(dimmingMainContent);
        $('body').addClass('overflow_hidden');
        $('.burder_menu').addClass('js_open');
        $('.burder_menu .dropdawn_list').addClass('js_open_drop').removeClass('dropdawn_list');

        $('.js_close_menu').on('click', function () {
            $('.bg_modal').remove();
            $('.burder_menu').removeClass('js_open');
            $('body').removeClass('overflow_hidden');
        });

        $('.bg_modal').on('click', function () {
            $('.bg_modal').remove();
            $('body').removeClass('overflow_hidden');
            $('.js_close_menu').trigger('click');
        });

        $('.js_open_drop').closest('.dropdown_parent').find('.open_icon').on('click', function (e) {
            e.preventDefault();
            const dropBody = $(this).closest('.dropdown_parent').find('.js_open_drop');
            const dropMenuBody = $(this).closest('.dropdown_parent').find('.js_mob');
            const linkPerent = $(this);

            $(this).closest('.dropdown_parent').toggleClass('js_hover');
            dropBody.toggleClass('js_open');

            if (dropMenuBody.find($('.title_parent')).length != 1) {
                dropMenuBody.prepend(`<li class='close_btn'>
                    <button type='button' class='js_close_menu_level'>
                        Меню
                    </button>
                    <p class='title_parent'>${linkPerent.text()}</p>
                </li>`);
                dropMenuBody.prepend(`<li class='close_abs'>
                    <button type='button' class='close_button js_close_menu_level'>
                        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'>
                            <path data-name='cross' d='M.227 1.335a.8.8 0 0 1 0-1.11.8.8 0 0 1 1.11 0L8 6.9 14.67.225a.781.781 0 0 1 1.1 1.11L9.108 8l6.661 6.67a.781.781 0 0 1-1.1 1.11L8 9.1l-6.661 6.67a.8.8 0 0 1-1.11 0 .8.8 0 0 1 0-1.11L6.888 8z' transform='translate(-.002)' style='fill:#494b55'/>
                        </svg>
                    </button>
                </li>`);
            }

            $('.js_close_menu_level').on('click', function () {
                $(this).closest('.js_open_drop').removeClass('js_open');
                $(this).closest('.dropdown_parent').removeClass('js_hover')
            });
        });

        $('.js_open_menu').on('click', function () {
            const linkPerent = $(this);
            const wrapMenuLevel = $(this).closest('.menu').find('.menu_block');
            // const itemMenu = $(this).closest('.menu').find('.first_level');
            wrapMenuLevel.addClass('js_open_mob_menu');

            if (wrapMenuLevel.find('.close_abs').length < 1) {
                wrapMenuLevel.prepend(`<div class='close_btn'>
                    <button type='button' class='js_close_menu_level'>
                        Меню
                    </button>
                    <p class='title_parent'>${linkPerent.text()}</p>
                </div>`);
                wrapMenuLevel.prepend(`<div class='close_abs'>
                    <button type='button' class='close_button js_close_menu_level'>
                        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'>
                            <path data-name='cross' d='M.227 1.335a.8.8 0 0 1 0-1.11.8.8 0 0 1 1.11 0L8 6.9 14.67.225a.781.781 0 0 1 1.1 1.11L9.108 8l6.661 6.67a.781.781 0 0 1-1.1 1.11L8 9.1l-6.661 6.67a.8.8 0 0 1-1.11 0 .8.8 0 0 1 0-1.11L6.888 8z' transform='translate(-.002)' style='fill:#494b55'/>
                        </svg>
                    </button>
                </div>`);
            }

            $('.js_perent_block').on('click', function (e) {
                e.preventDefault();
                const valueCat = $(this).attr('data-catsname');
                $('.mob_body .menu_children_menu').addClass('js_childre_open')

                $(`.mob_body .second_level[data-catschildren=${valueCat}]`).show();

                if ($(`.mob_body .second_level[data-catschildren=${valueCat}] .close_btn`).length != 1) {
                    $(`.mob_body .second_level[data-catschildren=${valueCat}]`).prepend(`<div class='close_btn'>
                        <button type='button' class='js_close_menu_level_two'>
                            Меню
                        </button>
                        <p class='title_parent'>${$(this).children('a').html()}</p>
                    </div>`);
                    $(`.mob_body .second_level[data-catschildren=${valueCat}]`).prepend(`<div class='close_abs'>
                        <button type='button' class='close_button js_close_menu_level_two'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'>
                                <path data-name='cross' d='M.227 1.335a.8.8 0 0 1 0-1.11.8.8 0 0 1 1.11 0L8 6.9 14.67.225a.781.781 0 0 1 1.1 1.11L9.108 8l6.661 6.67a.781.781 0 0 1-1.1 1.11L8 9.1l-6.661 6.67a.8.8 0 0 1-1.11 0 .8.8 0 0 1 0-1.11L6.888 8z' transform='translate(-.002)' style='fill:#494b55'/>
                            </svg>
                        </button>
                    </div>`);
                }

                $('.js_close_menu_level_two').on('click', function () {
                    $(this).closest('.menu_children_menu').removeClass('js_childre_open');
                    $(this).closest('.second_level').hide();
                });
            })

            $('.js_close_menu_level').on('click', function () {
                $(this).closest('.menu_block').removeClass('js_open_mob_menu');
            });
        });
    });

    activeHoverMainPageMenu();
});

const activeHoverMainPageMenu = function () {
    if ($(window).outerWidth() > 769) {
        $('.js_active_parent:not(.hover_item_menu)').off();
        $('.js_active_parent:not(.hover_item_menu)').hover(function () {
            const heightGarage = $('.js__height_garage_block').outerHeight(true);
            heightMainMenu = $('.cat_main_page .first_level_block').outerHeight(true);
            $('.js_activation_block_cat_children').css({
                'height': `${heightMainMenu}px`,
                'top': `${heightGarage}px`,
            });
            $('.js_active_parent').removeClass('hover_item_menu');
            $('.second_level').removeClass('js_open_block');
            const catId = $(this).attr('data-catsName');
            $(this).addClass('hover_item_menu');
            $('.js_activation_block_cat_children').addClass('js_open_block');
            if (catId) {
                $(`.js_activation_block_cat_children .second_level[data-catsChildren=${catId}]`).addClass('js_open_block');
                menuRebuild(namRow);
            }
        }, function () {
            $('.section_page').hover(function () {
                $('.js_activation_block_cat_children').removeClass('js_open_block');
                $('.js_active_parent').removeClass('hover_item_menu');
                $('.second_level').removeClass('js_open_block');
            })
        });
    }
}

window.activeHoverMainPageMenu = activeHoverMainPageMenu;

function menuRebuild(row) {
    $('.second_level').each(function () {
        let fullHeightElement = 0;

        $(this).find('.second_level_title').each(function () {
            let heightElement = $(this).outerHeight(true);
            fullHeightElement += heightElement;
        });

        if (heightMainMenu < fullHeightElement) {
            $(this).css('height', `${fullHeightElement / row + 120}px`);
        }
    });
}

const heightCat = $('.cat_main_page .first_level_block').outerHeight(true);

function getMainBanerHeight() {
    if ($(window).outerWidth() > 769) {
        const height = $('.block_cats_slider').outerHeight(true);

        if (height > 10 && heightCat > height) {
            $('.cat_main_page .first_level_block').css('height', `${height}px`);
            if ($('.first_level_block .span_open').length != 1) {
                $('.first_level_block').append(`<span class='span_open'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15 15'>
                        <path data-name='Контур 1443' d='M10.919.147a.567.567 0 0 0-.767 0l-4.6 4.6L.947.147A.574.574 0 0 0 .538 0a.567.567 0 0 0-.386.953l5 5a.565.565 0 0 0 .4.167.569.569 0 0 0 .4-.166l5-5.006a.568.568 0 0 0-.04-.8' transform='translate(2 4.4)' style='fill:#212121'/>
                    </svg>
                </span>`)
            }
        }

        $('.span_open').on('click', function () {
            $(this).toggleClass('js_open');
            if ($(this).hasClass('js_open')) {
                $('.cat_main_page .first_level_block').css('height', ``);
            } else {
                $('.cat_main_page .first_level_block').css('height', `${height}px`);
            }
        });

        if ($(window).outerWidth() > 540) {
            $('.js__leads_list').hover(function () {
                $(this).addClass('js_open');
                $('.cabinet_tools').addClass('js__active_cabinet')
            }, function () {
                $(this).removeClass('js_open');
                $('.cabinet_tools').removeClass('js__active_cabinet')
            });
        }
    } else {
        $('.cat_main_page .first_level_block').css('height', `100%`);
    }
}


function headerSliderBlock() {
    let currentSlide = 0;
    const slides = $('.header_slide');
    const totalSlides = slides.length;
    const slideHeight = 40;

    if (totalSlides <= 1) return;

    function slide() {
        slides.removeClass('active');
        currentSlide = (currentSlide + 1) % totalSlides;
        slides.eq(currentSlide).addClass('active');
    }

    slides.eq(0).addClass('active');

    setInterval(slide, 10000);
}

$(document).ready(function () {
    getMainBanerHeight();

    if ($('.header_slider_container').length) {
        headerSliderBlock();
    }

    $(window).resize(function () {
        getMainBanerHeight();
    });
})